var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.875C19.2485 10.8735 20.1103 11.0762 20.8916 11.4669C21.6729 11.8575 22.3521 12.4253 22.875 13.125",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.125C1.64794 12.4253 2.32714 11.8575 3.10843 11.4669C3.88972 11.0762 4.75149 10.8735 5.625 10.875",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 20.25C7.09399 19.2386 7.86205 18.3861 8.81677 17.7899C9.77148 17.1936 10.8745 16.8774 12.0001 16.8774C13.1257 16.8774 14.2287 17.1936 15.1834 17.7899C16.1381 18.3861 16.9062 19.2386 17.4001 20.25",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62512 10.875C5.05572 10.8756 4.49791 10.7141 4.01688 10.4094C3.53585 10.1048 3.15145 9.6695 2.9086 9.15449C2.66576 8.63947 2.57449 8.06598 2.64547 7.50102C2.71645 6.93607 2.94675 6.40298 3.30945 5.96404C3.67215 5.52511 4.15227 5.19845 4.69372 5.02225C5.23517 4.84605 5.81558 4.82758 6.36714 4.96899C6.9187 5.11041 7.41862 5.40587 7.8085 5.82085C8.19838 6.23583 8.4621 6.7532 8.56887 7.3125",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4312 7.3125C15.5379 6.7532 15.8016 6.23583 16.1915 5.82085C16.5814 5.40587 17.0813 5.11041 17.6329 4.96899C18.1844 4.82758 18.7648 4.84605 19.3063 5.02225C19.8477 5.19845 20.3279 5.52511 20.6906 5.96404C21.0533 6.40298 21.2836 6.93607 21.3545 7.50102C21.4255 8.06598 21.3343 8.63947 21.0914 9.15449C20.8486 9.6695 20.4642 10.1048 19.9831 10.4094C19.5021 10.7141 18.9443 10.8756 18.3749 10.875",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersThree);
export default __webpack_public_path__ + "static/media/UsersThree.e32f4542bd77fddb85f628f63a07c146.svg";
export { ForwardRef as ReactComponent };